import React, { useState, useEffect, useRef } from 'react';

const SplitHero = ({ onChoose, onClose }) => {
  const [pending, setPending] = useState('seller');
  const [chosen, setChosen] = useState(false);
  const [scrollScale, setScrollScale] = useState(1);
  const particlesMspRef = useRef(null);
  const particlesMipRef = useRef(null);

  useEffect(() => {
    const buildParticles = (container, color) => {
      if (!container) return;
      container.innerHTML = '';
      for (let i = 0; i < 18; i++) {
        const p = document.createElement('div');
        p.style.cssText = `
          position:absolute;
          width:${1 + Math.random() * 2}px;
          height:${1 + Math.random() * 2}px;
          border-radius:50%;
          background:${color};
          left:${5 + Math.random() * 90}%;
          bottom:${5 + Math.random() * 50}%;
          opacity:0;
          animation:mspParticleDrift ${3 + Math.random() * 4}s linear ${Math.random() * 3}s infinite;
          pointer-events:none;
        `;
        container.appendChild(p);
      }
    };
    buildParticles(particlesMspRef.current, 'rgba(20,184,166,0.7)');
    buildParticles(particlesMipRef.current, 'rgba(37,99,235,0.6)');
  }, []);

  useEffect(() => {
    let touchStartY = 0;

    const onWheel = (e) => {
      const scale = Math.min(1.6, 1 + (Math.abs(e.deltaY) / 80) * 0.23);
      setScrollScale(scale);
    };

    const onTouchStart = (e) => {
      touchStartY = e.touches[0].clientY;
    };

    const onTouchMove = (e) => {
      const delta = touchStartY - e.touches[0].clientY;
      const scale = Math.min(1.3, 1 + (Math.abs(delta) / 80) * 0.06);
      setScrollScale(scale);
    };

    window.addEventListener('wheel', onWheel, { passive: true });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true });

    return () => {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
    };
  }, []);

  const handleChoose = (side, e) => {
    if (e) e.stopPropagation();
    setChosen(true);
    localStorage.setItem('preferredTool', side);
    setTimeout(() => onChoose(side), 800);
  };

  return (
    <section style={{
      position: 'fixed',
      inset: 0,
      top: '6vh',
      zIndex: 10,
      display: 'flex',
      overflow: 'hidden',
      pointerEvents: chosen ? 'none' : 'auto',
    }}>
      <style>{`
        @keyframes mspParticleDrift {
          0%   { transform: translateY(0) translateX(0); opacity: 0; }
          10%  { opacity: 1; }
          90%  { opacity: 0.4; }
          100% { transform: translateY(-160px) translateX(10px); opacity: 0; }
        }
        @keyframes mspPulseRing {
          0%   { transform: scale(1); opacity: 0.6; }
          100% { transform: scale(2.2); opacity: 0; }
        }
        @keyframes hintBounce {
          0%, 100% { transform: translateY(0); }
          50%       { transform: translateY(5px); }
        }

        /* ── shared panel ── */
        .sh-panel {
          flex: 1;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          cursor: pointer;
          padding: 60px 48px 80px;
          transition: transform 0.95s cubic-bezier(0.76, 0, 0.24, 1);
        }

        /* ── desktop: side by side, slide left/right ── */
        @media (min-width: 641px) {
          .sh-panel-left {
            background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #e0f2fe 100%);
            border-right: 1px solid rgba(20,184,166,0.2);
          }
          .sh-panel-right {
            background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 50%, #f8fafc 100%);
          }
          .sh-panel-left.open  { transform: translateX(-100%); }
          .sh-panel-right.open { transform: translateX(100%); }

          .sh-panel-left.pending-active  { background: linear-gradient(135deg, #f0fdf9 0%, #e0f2fe 100%); }
          .sh-panel-right.pending-active { background: linear-gradient(135deg, #eff6ff 0%, #eef2ff 100%); }

          .sh-divider {
            position: absolute; left: 50%; top: 10%; bottom: 10%; width: 1px;
            background: linear-gradient(to bottom, transparent, rgba(20,184,166,0.35) 30%, rgba(20,184,166,0.35) 70%, transparent);
            z-index: 5; pointer-events: none;
          }
          .sh-logo-pin {
            position: absolute; left: 50%; top: 50%;
            transform: translate(-50%, -50%);
            z-index: 10; pointer-events: none;
            transition: opacity 0.35s ease;
          }
        }

        /* ── mobile: stacked, slide up/down ── */
        @media (max-width: 640px) {
          section {
            flex-direction: column !important;
          }
          .sh-panel {
            padding: 36px 24px 36px;
            flex: 1;
            border-right: none !important;
          }
          .sh-panel-left {
            background: linear-gradient(135deg, #f8fafc 0%, #f0f9ff 50%, #e0f2fe 100%);
            border-bottom: 1px solid rgba(20,184,166,0.2) !important;
          }
          .sh-panel-right {
            background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 50%, #f8fafc 100%);
          }
          .sh-panel-left.open  { transform: translateY(-100%); }
          .sh-panel-right.open { transform: translateY(100%); }

          .sh-panel-left.pending-active  { background: linear-gradient(135deg, #f0fdf9 0%, #e0f2fe 100%); }
          .sh-panel-right.pending-active { background: linear-gradient(135deg, #eff6ff 0%, #eef2ff 100%); }

          .sh-brand { font-size: 36px !important; }
          .sh-eyebrow { margin-bottom: 12px !important; }
          .sh-sub { margin-bottom: 16px !important; }

          /* horizontal divider on mobile */
          .sh-divider {
            position: absolute; top: 50%; left: 10%; right: 10%; height: 1px; width: auto;
            background: linear-gradient(to right, transparent, rgba(20,184,166,0.35) 30%, rgba(20,184,166,0.35) 70%, transparent);
            z-index: 5; pointer-events: none;
          }
          .sh-logo-pin {
            position: absolute; left: 50%; top: 50%;
            transform: translate(-50%, -50%);
            z-index: 10; pointer-events: none;
            transition: opacity 0.35s ease;
          }
        }

        .sh-logo-pin.hidden { opacity: 0; }

        /* glows */
        .sh-glow {
          position: absolute; inset: 0; pointer-events: none;
          opacity: 0; transition: opacity 0.4s;
        }
        .sh-panel-left  .sh-glow { background: radial-gradient(ellipse at 40% 50%, rgba(20,184,166,0.12) 0%, transparent 65%); }
        .sh-panel-right .sh-glow { background: radial-gradient(ellipse at 60% 50%, rgba(37,99,235,0.12) 0%, transparent 65%); }
        .sh-panel:hover .sh-glow { opacity: 1; }

        /* particles */
        .sh-particles {
          position: absolute; inset: 0; pointer-events: none;
          opacity: 0; transition: opacity 0.5s;
        }
        .sh-panel:hover .sh-particles { opacity: 1; }

        /* icon */
        .sh-icon-wrap {
          position: relative; margin-bottom: 16px;
          transition: transform 0.45s ease;
        }
        .sh-panel:hover .sh-icon-wrap { transform: scale(1.08) translateY(-6px); }
        .sh-icon-circle {
          width: 64px; height: 64px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          position: relative; z-index: 1;
        }
        .sh-pulse {
          position: absolute; width: 64px; height: 64px; border-radius: 50%;
          top: 0; left: 0;
          opacity: 0; animation: mspPulseRing 2.4s ease-out infinite;
          transition: opacity 0.3s;
        }
        .sh-pulse-2 { animation-delay: 0.8s; }
        .sh-panel:hover .sh-pulse { opacity: 1; }

        /* text */
        .sh-eyebrow {
          font-size: 11px; font-weight: 500; letter-spacing: 0.1em;
          text-transform: uppercase; padding: 4px 14px; border-radius: 20px;
          margin-bottom: 20px; transition: transform 0.4s ease;
        }
        .sh-panel:hover .sh-eyebrow { transform: translateY(-4px); }

        .sh-brand {
          font-size: 52px; font-weight: 300; color: #0f172a;
          line-height: 1.1; text-align: center; letter-spacing: -1px;
          margin-bottom: 8px; transition: transform 0.45s ease;
        }
        .sh-panel:hover .sh-brand { transform: translateY(-6px); }

        .sh-sub {
          font-size: 14px; color: #94a3b8; text-align: center;
          letter-spacing: 0.04em; font-weight: 300; margin-bottom: 36px;
          transition: transform 0.4s ease, color 0.3s;
        }
        .sh-panel:hover .sh-sub { transform: translateY(-4px); color: #64748b; }

        /* features */
        .sh-features {
          display: flex; flex-direction: column; gap: 8px;
          width: 100%; max-width: 260px;
          opacity: 0; transform: translateY(18px);
          transition: opacity 0.4s ease 0.08s, transform 0.4s ease 0.08s;
        }
        .sh-panel:hover .sh-features { opacity: 1; transform: translateY(0); }
        @media (max-width: 640px) {
          .sh-features { display: none; }
        }

        .sh-feat {
          display: flex; align-items: center; gap: 10px;
          padding: 9px 14px; border-radius: 12px;
          background: rgba(255,255,255,0.8);
          transition: transform 0.2s;
        }
        .sh-feat:hover { transform: translateX(4px); }
      `}</style>

      {onClose && (
        <button
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          style={{
            position: 'absolute', top: 36, right: 16, zIndex: 20,
            width: 36, height: 36, borderRadius: '50%', border: 'none',
            background: 'rgba(15,23,42,0.08)', color: '#0f172a', fontSize: 18,
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          aria-label="Close"
        >
          ✕
        </button>
      )}

      {/* blobs */}
      <div style={{ position: 'absolute', width: 500, height: 500, borderRadius: '50%', filter: 'blur(60px)', background: 'linear-gradient(90deg,rgb(20,184,166),rgb(37,99,235))', top: -200, left: -100, opacity: 0.07, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', filter: 'blur(60px)', background: 'linear-gradient(90deg,rgb(20,184,166),rgb(37,99,235))', top: -160, right: '22%', opacity: 0.07, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', filter: 'blur(60px)', background: 'linear-gradient(90deg,rgb(20,184,166),rgb(37,99,235))', bottom: 40, left: 60, opacity: 0.07, pointerEvents: 'none' }} />

      {/* ── LEFT / TOP - Seller Pro ── */}
      <div
        className={`sh-panel sh-panel-left ${chosen ? 'open' : ''} ${pending === 'seller' && !chosen ? 'pending-active' : ''}`}
        style={{ marginTop: window.innerWidth < 641 && "2vh" }}
        onMouseEnter={() => setPending('seller')}
        onClick={() => handleChoose('seller')}
      >
        <div className="sh-glow" />
        <div className="sh-particles" ref={particlesMspRef} />

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}>
          <div className="sh-icon-wrap">
            <div className="sh-pulse" style={{ border: '1px solid rgba(20,184,166,0.5)' }} />
            <div className="sh-pulse sh-pulse-2" style={{ border: '1px solid rgba(20,184,166,0.5)' }} />
            <div className="sh-icon-circle" style={{ background: 'linear-gradient(135deg,rgba(20,184,166,0.15),rgba(20,184,166,0.05))', border: '1px solid rgba(20,184,166,0.3)' }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" /><path d="M16 10a4 4 0 01-8 0" />
              </svg>
            </div>
          </div>

          <div className="sh-eyebrow" style={{ background: 'rgba(20,184,166,0.1)', color: '#0f766e', border: '1px solid rgba(20,184,166,0.25)' }}>For sellers</div>
          <div className="sh-brand"><em style={{ color: '#0d9488', fontStyle: 'italic' }}>Seller</em> Pro</div>
          <div className="sh-sub" style={{ display: "flex", gap: "4px" }}>
            <img style={{ width: 24, height: 24, objectFit: "contain", marginTop: "1.5px" }} src="/icons/amazon.png" /> (🇺🇸·🇬🇧·🇨🇦·🇲🇽) ·
            <img style={{ width: 24, height: 24, objectFit: "contain" }} src="/icons/walmart.png" /> ·
            <img style={{ width: 24, height: 24, objectFit: "contain" }} src="/icons/ebay.png" /></div>

          <div className="sh-features">
            {['Online/Retail Arbitrage Tools', 'The BEST Wholesale Scanner', 'Storefront Stalking And More!'].map((f, i) => (
              <div className="sh-feat" key={i} style={{ border: '1px solid rgba(20,184,166,0.18)' }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#14b8a6', flexShrink: 0 }} />
                <span style={{ fontSize: 13, color: '#475569' }}>{f}</span>
              </div>
            ))}
          </div>

          <button
            style={{
              marginTop: window.innerWidth < 641 ? 12 : 24,  // was 24
              padding: window.innerWidth < 641 ? '9px 22px' : '12px 32px',  // was 12px 32px
              fontSize: window.innerWidth < 641 ? 13 : 15,  // was 15
              borderRadius: 30,
              border: 'none',
              background: 'linear-gradient(135deg, #0d9488, #2563eb)',
              color: 'white',
              fontWeight: 500,
              cursor: 'pointer',
              transform: `scale(${scrollScale})`,
              transition: 'transform 0.15s ease',
              transformOrigin: 'center',
            }}
            onClick={(e) => handleChoose('seller', e)}
          >
            Enter Seller Pro →
          </button>
        </div>
      </div>

      {/* ── CENTER divider + logo ── */}
      <div className="sh-divider" style={{ opacity: chosen ? 0 : 1, transition: 'opacity 0.3s ease', marginTop: window.innerWidth < 641 && "1vh" }} />
      <div className={`sh-logo-pin ${chosen ? 'hidden' : ''}`}>
        <div style={{
          width: window.innerWidth < 641 ? 32 : 72,
          height: window.innerWidth < 641 ? 32 : 72,
          borderRadius: '50%',
          background: 'white',
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: window.innerWidth < 641 && "2vh"
        }}>
          <img src="/logo512.png" alt="MSP" style={{ width: window.innerWidth < 641 ? 20 : 48, height: window.innerWidth < 641 ? 20 : 48, objectFit: 'contain' }} />
        </div>
      </div>

      {/* ── RIGHT / BOTTOM - Influencer Pro ── */}
      <div
        className={`sh-panel sh-panel-right ${chosen ? 'open' : ''} ${pending === 'influencer' && !chosen ? 'pending-active' : ''}`}
        onMouseEnter={() => setPending('influencer')}
        onClick={() => handleChoose('influencer')}
      >
        <div className="sh-glow" />
        <div className="sh-particles" ref={particlesMipRef} />

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}>
          <div className="sh-icon-wrap">
            <div className="sh-pulse" style={{ border: '1px solid rgba(37,99,235,0.5)' }} />
            <div className="sh-pulse sh-pulse-2" style={{ border: '1px solid rgba(37,99,235,0.5)' }} />
            <div className="sh-icon-circle" style={{ background: 'linear-gradient(135deg,rgba(37,99,235,0.15),rgba(37,99,235,0.05))', border: '1px solid rgba(37,99,235,0.25)' }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M23 7l-7 5 7 5V7z" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
              </svg>
            </div>
          </div>

          <div className="sh-eyebrow" style={{ background: 'rgba(37,99,235,0.1)', color: '#1d4ed8', border: '1px solid rgba(37,99,235,0.2)' }}>For creators</div>
          <div className="sh-brand"><em style={{ color: '#2563eb', fontStyle: 'italic' }}>Influencer</em> Pro</div>
          <div className="sh-sub">Amazon Influencer Program (AIP)</div>

          <div className="sh-features">
            {['AIP Mobile & Chrome App', 'AIP Video Studio', 'Creator Connections'].map((f, i) => (
              <div className="sh-feat" key={i} style={{ border: '1px solid rgba(37,99,235,0.18)' }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#3b82f6', flexShrink: 0 }} />
                <span style={{ fontSize: 13, color: '#475569' }}>{f}</span>
              </div>
            ))}
          </div>

          <button
            style={{
              marginTop: window.innerWidth < 641 ? 12 : 24,  // was 24
              padding: window.innerWidth < 641 ? '9px 22px' : '12px 32px',  // was 12px 32px
              fontSize: window.innerWidth < 641 ? 13 : 15,  // was 15
              borderRadius: 30,
              border: 'none',
              background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
              color: 'white',
              fontWeight: 500,
              cursor: 'pointer',
              transform: `scale(${scrollScale})`,
              transition: 'transform 0.15s ease',
              transformOrigin: 'center',
            }}
            onClick={(e) => handleChoose('influencer', e)}
          >
            Enter Influencer Pro →
          </button>
        </div>
      </div>

      {/* hint */}
      <div style={{
        position: 'absolute',
        bottom: window.innerWidth < 641 ? 0 : 20,
        left: '50%',
        transform: `translateX(-50%) scale(${scrollScale})`,
        transformOrigin: 'center bottom',
        opacity: chosen ? 0 : window.innerWidth < 641 ? 0 : 1,
        transition: 'opacity 0.4s, transform 0.15s ease',
        fontSize: 11,
        color: scrollScale > 1.1 ? '#0f766e' : '#94a3b8',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        fontWeight: 300,
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        zIndex: 5,
      }}>
        {scrollScale < 1.05 ? 'Click to enter' : '👆 Click to enter! 👆'}
      </div>
    </section>
  );
};

export default SplitHero;